var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{staticClass:"page-loader"},[_c('logo-composite',{attrs:{"centered":"","label":_vm.$t('logos.radio17')}}),_c('v-progress-linear',{attrs:{"color":"secondary","rounded":"","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }